/**
 * API response enrichment for route stops.
 *
 * Adds derived fields (actionId, exceptionIds, photoStatus, tagIds)
 * to raw stop data from route stop API responses.
 *
 * Moved from utils/route.js lines 204-222.
 */
import { get } from 'lodash'
import { getActionTypeAndLabel } from 'components/services/ServiceActionTypeHelper'
import { getTagIds } from 'utils/tags'
import { NO_EXCEPTIONS_OPTION, PHOTO_IDS } from 'containers/new-route-manager/settings'

/**
 * Enriches raw stop data with derived display fields.
 *
 * @param {Object[]} stops - raw stops from API response
 * @returns {Object[]} stops with added actionId, exceptionIds, photoStatus, tagIds
 */
export const transformResponse = stops =>
  stops.map(stop => {
    const { id: actionId } = getActionTypeAndLabel(
      get(stop, 'eventActionType'),
      get(stop, 'serviceActionType'),
      get(stop, 'pricedServiceType')
    )
    const exceptions = get(stop, 'exceptions', [])
    const exceptionIds = exceptions.map(exception => get(exception, 'exceptionType'))
    const photos = exceptions.filter(exception => get(exception, 'fileLocation'))

    return {
      ...stop,
      actionId,
      exceptionIds: exceptionIds.length > 0 ? exceptionIds : [NO_EXCEPTIONS_OPTION.id],
      photoStatus: photos.length > 0 ? PHOTO_IDS.WITH_PHOTOS : PHOTO_IDS.WITHOUT_PHOTOS,
      tagIds: getTagIds(get(stop, 'tags', {})),
    }
  })
